var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-transparent d-flex m-t-16 m-d-16"},[_c('div',{staticClass:"f-regular font-16 f-c-blue status-login"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" Langkah "+_vm._s(_vm.step)+"/"+_vm._s(_vm.total)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }